module.exports = "\n<app-nav-bar></app-nav-bar>\n\n\n<router-outlet></router-outlet>"